import React, {useEffect, useState, useCallback} from 'react';
import moment from 'moment';
import { getUserPreference, getRefererFromId } from '../../../../utilities/common';
import { TextField, InputAdornment, OutlinedInput, Fab, Box} from '@material-ui/core';
import { Refresh, Search } from '@material-ui/icons';
import {DataGrid} from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme)=> ({
    root: {
        display: 'flex', 
        flexDirection: 'column', 
        height: '100%'
    }
}))
function SelectBatchTable(props){
    const classes = useStyles();
    const {t} = useTranslation('mapManagement');
    const userPref = getUserPreference();

    const slotManagement = useSelector(state => state.saReducer);

    const [searchKeyword, setSearchKeyword] = useState([""]);
    const [filter, setFilter] = useState({
        count: userPref.selectBatchCountFilter || 20,
        dateAfter: moment().subtract(30, 'days')
    })
    const [data, setData] = useState([])
    const [selectTable, setSelectTable] = useState([])
    
    const delaySearch = useCallback(_.debounce(value=>setSearchKeyword(value), 350), [])
    const delayFilter = useCallback(_.debounce(value=>setFilter(value), 350), [])

    useEffect(()=> {
        let filteredData = filterData(props.batchList, filter)
        let filteredSearch = filterSearch(filteredData)
        setData(filteredSearch)
    }, [filter, props.batchList, searchKeyword, props.branch])

    useEffect(()=> {
        if(props.batchList && props.batchList.length > 0){
            setSelectTable(getBatchIdsByReferer())
        }
    }, [props.batchList, props.branch])

    useEffect(() => {
        props.fetchTimestamp(filter.dateAfter);
    }, [filter])

    const columns = [
        {field: 'referer', headerName: t('batch_number_header'), flex: 1},
        {field: 'refer_count', headerName: t('order_count_header'), type: 'number', width: 100},
        {field: 'eta', headerName: t('common:date'), type: 'date', flex: 1,
            valueFormatter: (params)=> moment.unix(params.value).format("MMM DD, YYYY")},
        {field: 'dispatch_no', headerName: t('dispatch_number'), flex: 1}
    ]

    return (
        <div className={classes.root}>
            <form style={{flexDirection: 'row', paddingBottom: 16}}>
                <TextField 
                    id="filter-date"
                    label={t('common:from_date')}
                    type="date"
                    variant="outlined"
                    defaultValue={filter.dateAfter.format("YYYY-MM-DD")}
                    onChange={handleFilterDateChange}
                    style={{paddingRight: 16}}
                />
                <TextField 
                    id="filter-count"
                    label={t('minimum_count')}
                    type='number'
                    variant='outlined'
                    defaultValue={filter.count}
                    onChange={handleFilterCountChange}
                    style={{width: 150}}
                />
                <OutlinedInput 
                    startAdornment={
                        <InputAdornment position='start'>
                            <Search />
                        </InputAdornment>
                    }
                    placeholder={t('common:search')}
                    onChange={handleSearchChange}
                    style={{float: 'right'}}
                />
            </form>
            <div style={{flexGrow: 1}}>
                <div style={{position:'relative'}}>
                    <Box 
                        m={1}
                        style={{
                            position: 'absolute', 
                            right: 0,
                            zIndex: 1
                        }}
                    >
                        <Fab
                            color="primary" 
                            aria-label='refresh' 
                            size="small"
                            onClick={_handleBatchListRefresh}
                            style={{
                                marginLeft: 4
                            }}
                        >
                            <Refresh />
                        </Fab>
                    </Box>
                </div>
                <div style={{display: 'flex', height: '100%'}}>
                    <div style={{flexGrow: 1}}>
                        <DataGrid 
                            columns={columns} 
                            rows={data}
                            sortModel={[{
                                field: "eta",
                                sort: 'desc'
                            }]}
                            state={{
                                keyboard: {
                                  cell: null,
                                  columnHeader: null,
                                  isMultipleKeyPressed: false,
                                }}}
                            onSelectionModelChange={(newSelection) => {
                                //Not preferred method, HOWEVER our data is number but data grid takes/outputs strings
                                //This is to ensure the data matching with states would be correct
                                //let ids = _.map(newSelection.selectionModel, Number)
                                setSelectTable(newSelection)
                                props.onTableSelection(newSelection)
                                let batches = getRefererFromId(slotManagement.batches, newSelection);
                                props.onBatchSelection(batches);
                            }}
                            selectionModel={selectTable}
                            loading={props.isLoading}
                            checkboxSelection
                            autoPageSize
                            disableColumnFilter
                            disableColumnMenu
                        />
                    </div>
                </div>
            </div>
        </div>
    )

    function getSelectedItems(batchList, selectedIds){
        //This function is used to make sure selectionModel won't go crazy when items disappear but ids are still intact
        let result = _.map(selectedIds, (id)=>{
            if (_.findIndex(batchList, (batch) => batch.id === id) !== -1){
                return id
            }
        })
        return _.compact(result)
    }

    function filterData(batchList, filter){
        // return _.filter(batchList, function(batch){return batch.refer_count >= filter.count && batch.eta >= filter.dateAfter.unix()})
        return _.filter(batchList, function(batch){return batch.refer_count >= filter.count})
    }

    function filterSearch(array){
        let preserveChecked = []
        let filter = [];
        if(searchKeyword?.length > 0) {
            searchKeyword.forEach((keyword) => {
                let keywordFilter = _.filter(array, (item)=> {
                    return item.dispatch_no?.match(new RegExp(keyword, 'i')) || item.referer.match(new RegExp(keyword, 'i'));
                })
                filter = _.union(filter, keywordFilter);
            })
        }
        if(selectTable){
            preserveChecked = _.filter(array, (item)=> selectTable.includes(item.id))
        }
        return _.union(filter, preserveChecked)
    }

    function getBatchIdsByReferer(){
        let findBatches = _.intersectionWith(props.batchList, props.selectedBatches, (batch, referer) => batch.referer === referer)
        console.log(findBatches)
        return _.map(findBatches, 'id')
    }

    function handleCreateSubBatch(){
        if(props.selectedBatches){
            props.createSubBatch(props.selectedBatches)
        }
    }

    function _handleBatchListRefresh(){
        if(!props.isLoading){
            props.fetchBatchList()
        }
    }

    function handleSearchChange(event){
        if(event.target.value) {
            delaySearch(event.target.value.split(','))
        } else {
            delaySearch([""])
        }
    }

    function handleFilterCountChange(event){
        delayFilter({...filter, count: event.target.value})
        window.localStorage.setItem('select_batch_count_filter', event.target.value)
    }

    function handleFilterDateChange(event){
        delayFilter({...filter, dateAfter: moment(event.target.value)})
    }
}

SelectBatchTable.defaultProps = {
    batchList: []
}

export default SelectBatchTable